import * as types from "../constants/ActionTypes";
import {
  NEW_NOTE_SCREEN,
  SHOW_NOTE_SCREEN,
  NOTES_LIST_SCREEN
} from "../constants/Env";

export const initialState = {
  loading: true,
  currentNote: undefined,
  showSecureNotePanel: false,
  notes: undefined,
  screen: undefined,
  error: undefined
};

function notes(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ALL_SECURE_NOTES_RECEIVED:
      const { notes } = action;
      return {
        ...state,
        loading: false,
        notes,
        error: undefined
      };
    case types.FETCH_CURRENT_NOTE_RECEIVED:
      return {
        ...state,
        loading: false,
        currentNote: action.note,
        showSecureNotePanel: true,
        error: undefined
      };
    case types.SET_SCREEN_TO_NEW_NOTE:
      return {
        ...state,
        currentNote: undefined,
        showSecureNotePanel: true,
        screen: NEW_NOTE_SCREEN,
        error: undefined
      };
    case types.SET_SCREEN_TO_SHOW_NOTE:
      return {
        ...state,
        showSecureNotePanel: true,
        screen: SHOW_NOTE_SCREEN,
        error: undefined
      };
    case types.SET_SCREEN_TO_NOTES_LIST:
      return {
        ...state,
        currentNote: undefined,
        showSecureNotePanel: false,
        screen: NOTES_LIST_SCREEN,
        error: undefined
      };
    case types.SECURE_NOTES_DISABLED:
      return {
        ...state,
        error: {
          message:
            "Secure notes is currently disabled by the account owner. Contact your administrator"
        }
      };
    case types.CLEAR_NOTES_ERROR:
      return {
        ...state,
        error: undefined
      };
    default:
      return state;
  }
}

export default notes;
